import { render, staticRenderFns } from "./RecommendationItem.vue?vue&type=template&id=e49bb5a2&scoped=true&"
import script from "./RecommendationItem.vue?vue&type=script&lang=js&"
export * from "./RecommendationItem.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationItem.vue?vue&type=style&index=0&id=e49bb5a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49bb5a2",
  null
  
)

export default component.exports